import React, { forwardRef, useImperativeHandle, useRef } from 'react'
import SourceAnalysis from 'view/components/sourceAnalysis'
import StyleAnalysis from 'view/components/styleAnalysis'
import { SOURCE_TYPE } from '../../../../../privateComponent/pieAttrChart'

export default forwardRef(({ baseParams }, ref) => {
  const sourceAnalysisRef = useRef({})
  const styleAnalysis = useRef({})
  useImperativeHandle(ref, () => ({
    fetchSourceData: sourceAnalysisRef.current.onUpdate,
    fetchSourceStyleData: styleAnalysis.current.onUpdate
  }))
  return (<div>
    <SourceAnalysis
      baseParams={baseParams}
      ref={sourceAnalysisRef}
      pieSourceType={SOURCE_TYPE.HOME}
    />
    <StyleAnalysis
      style={{ marginTop: '16px' }}
      baseParams={baseParams}
      ref={styleAnalysis}
    />
  </div>)
})
